module.exports = __webpack_public_path__ + "static/media/Գարուն-Մարիետա-Բադալյան.b6e40754.mp3";